import { Component } from '@angular/core';
import { MatAnchor, MatButtonModule } from "@angular/material/button";
import { RouterLink, RouterLinkActive } from "@angular/router";

@Component({
  selector: 'app-top-sub-nav',
  imports: [MatButtonModule, MatAnchor, RouterLink, RouterLinkActive],
  templateUrl: './top-sub-nav.html',
  styleUrl: './top-sub-nav.scss',
})
export class TopSubNav {

}
